import queryString from 'query-string';
import {SelectOption} from "./CommonUIElementTypes";

export let UrlUtility = {
    getUrlQueryString: function (argumentsArray: SelectOption[]) {
        let queryString = '';
        let separator = '?';

        for (let i = 0; i < argumentsArray.length; i++) {
            let arg = argumentsArray[i];
            if (arg.value) {
                queryString += separator + arg.label + '=' + encodeURIComponent(arg.value);
                if (i === 0) {
                    separator = '&';
                }
            }
        }

        return queryString;
    },

    getQueryParamsFromSearchString: function (search?: string) {
        let queryParams = {};
        if (search) {
            queryParams = queryString.parse(search);
        }
        return queryParams;
    },

    getUrlQueryStringFromQueryParamsObject: function (queryParams: any) {
        let argumentsArray = [];
        let queryParamNames = Object.keys(queryParams);
        for (let i = 0; i < queryParamNames.length; i++) {
            let name = queryParamNames[i];
            argumentsArray.push({
                label: name,
                value: queryParams[name]
            });
        }

        return this.getUrlQueryString(argumentsArray)
    },
};
